import { render } from "./Classrooms.vue?vue&type=template&id=03c99337"
import script from "./Classrooms.vue?vue&type=script&lang=js"
export * from "./Classrooms.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__